<template>
  <footer class="site-footer">
    <div class="container">
      <nav class="footer-links">
        <router-link v-for="item in footerItems" :key="item.path" :to="item.path">
          {{ item.label }}
        </router-link>
      </nav>
      <p class="disclaimer">
        GBWaps is not affiliated with WhatsApp or Meta Platforms, Inc. This is an independent informational website.
      </p>
      <p class="copyright">© 2026 GBWaps. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
import { FOOTER_NAV } from '@/config/gbwaps';

export default {
  name: 'SiteFooter',
  data() {
    return {
      footerItems: FOOTER_NAV,
    };
  },
};
</script>
